import { c as _c } from "react/compiler-runtime";
import { delay } from "@utils/time-utils";
import { useCallback } from "react";

// Rate limiting: 100ms delay = max 10 requests/sec to avoid overwhelming the API
const RATE_LIMIT_DELAY_MS = 100;

/**
 * Response from a paginated API endpoint with cursor-based pagination
 */

/**
 * Parameters with optional cursor for pagination
 */

/**
 * Function signature for fetching a single page from a paginated API
 */

/**
 * Function signature for transforming raw API data to desired output format
 */

/**
 * Configuration for pagination property names used by different APIs
 */

/**
 * Configuration object for exporting all paginated data
 */

/**
 * Return value from useExportAllPaginated hook
 */

/**
 * Hook to export all paginated data with cancellation support.
 * Uses direct API calls instead of Redux thunk to avoid triggering store updates and re-renders.
 */
export function useExportAllPaginated() {
  const $ = _c(1);
  const exportAll = _temp;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      exportAll
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
async function _temp(config) {
  const {
    fetchParams,
    fetchPage,
    transform,
    onProgress,
    signal,
    paginationConfig
  } = config;
  const pagination = {
    requestParam: paginationConfig?.requestParam ?? "start",
    responseCursor: paginationConfig?.responseCursor ?? "next"
  };
  const results = [];
  let cursor;
  let page = 0;
  do {
    if (signal?.aborted) {
      return null;
    }
    page++;
    const response = await fetchPage({
      ...fetchParams,
      [pagination.requestParam]: cursor
    });
    if (signal?.aborted) {
      return null;
    }
    results.push(...transform(response.data));
    const nextCursor = response[pagination.responseCursor];
    cursor = typeof nextCursor === "string" ? nextCursor : undefined;
    onProgress?.(page);
    if (cursor) {
      await delay(RATE_LIMIT_DELAY_MS);
    }
  } while (cursor);
  return results;
}